export default {
  SET_CATEGORIES: (state, data) => {
    state.categories = data;
  },
  SET_CATEGORY: (state, data) => {
    state.category = data;
  },
};
